import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { ApplyForEoriCTA } from "./ctas";

export const ApplyForEoriIA: InstantAnswerBuilderFn = (
  strictLocalize,
  articles
) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },

  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize, articles)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize, articles)?.getLink?.();
    },
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => APPLY_FOR_EORI(strictLocalize),
    getDescription: () => [EORI_DEFINITION(strictLocalize)],
  };
};

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize, articles) => {
  return ApplyForEoriCTA(strictLocalize, articles);
};

const APPLY_FOR_EORI = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Apply for EORI number",
    description: {
      text: "Title for the answer of Apply for EORI number issue",
    },
  });

const EORI_DEFINITION = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Having an EORI number helps prevent potential delays and storage fees if your order is unable to be processed by customs in a timely fashion. We therefore recommend that you obtain an EORI number if you’re importing goods from another country. Please find country specific links to apply for EORI number below.",
    description: {
      text: "Description for the answer of Apply for EORI number. EORI stands for Economic Operators Registration and Identification.",
    },
  });
